<form
  name="DebtRecoveryForm"
  id="DebtRecoveryForm"
  [formGroup]="DebtRecoveryForm"
  fxLayout="column"
  fxLayoutAlign="start"
  class="one"
  fxFlex="1 0 auto"
>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEBTAMOUNT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEBTAMOUNT),
      }"
    >
      <mat-label>debt Amount</mat-label>
      <input
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        formControlName="DEBTAMOUNT"
        matTooltip="{{ toolTipList ? toolTipList?.DEBTAMOUNT?.HOVER : '' }}"
        [leadZero]="true"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList?.DEBTAMOUNT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DEBTAMOUNT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DEBTAMOUNT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.AMOUNTRECOVERED),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.AMOUNTRECOVERED),
      }"
    >
      <mat-label>Amount Recovered</mat-label>
      <input
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        formControlName="AMOUNTRECOVERED"
        matTooltip="{{ toolTipList ? toolTipList?.AMOUNTRECOVERED?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList?.AMOUNTRECOVERED) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.AMOUNTRECOVERED.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.AMOUNTRECOVERED?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEBTDUEDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEBTDUEDATE),
      }"
    >
      <mat-label>Debt Due Date</mat-label>
      <input
        (dateInput)="DebtdueDateSelect('input', $event)"
        (dateChange)="DebtdueDateSelect('change', $event)"
        matInput
        [matDatepicker]="DEBTDUEDATE"
        formControlName="DEBTDUEDATETEXT"
        matTooltip="{{ toolTipList ? toolTipList?.DEBTDUEDATETEXT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DEBTDUEDATE"></mat-datepicker-toggle>
      <mat-datepicker #DEBTDUEDATE></mat-datepicker>
      @if (testBool && toolTipList?.DEBTDUEDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DEBTDUEDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DEBTDUEDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.BALANCEOWING),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.BALANCEOWING),
      }"
    >
      <mat-label>Balance Owing</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        formControlName="BALANCEOWING"
        currencyMask
        readonly
        matTooltip="{{ toolTipList ? toolTipList?.BALANCEOWING?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList?.BALANCEOWING) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.BALANCEOWING.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.BALANCEOWING?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INTERESTRATETYPE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INTERESTRATETYPE),
      }"
    >
      <mat-label>Interest Type</mat-label>
      <mat-select
        name="INTERESTRATETYPE"
        formControlName="INTERESTRATETYPE"
        (selectionChange)="changeValue($event.value, 'string')"
      >
        <mat-option value="Compound">Compound</mat-option>
        <mat-option value="Simple">Simple</mat-option>
      </mat-select>
      @if (testBool && toolTipList?.INTERESTRATETYPE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INTERESTRATETYPE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.INTERESTRATETYPE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DEFAULTJUDGEMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DEFAULTJUDGEMENTDATE),
      }"
    >
      <mat-label>Default Judgement Date</mat-label>
      <input
        (dateInput)="DefaultjudgementDateSelect('input', $event)"
        (dateChange)="DefaultjudgementDateSelect('change', $event)"
        matInput
        [matDatepicker]="DEFAULTJUDGEMENTDATE"
        formControlName="DEFAULTJUDGEMENTDATETEXT"
        matTooltip="{{ toolTipList ? toolTipList?.DEFAULTJUDGEMENTDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      <mat-datepicker-toggle matSuffix [for]="DEFAULTJUDGEMENTDATE"></mat-datepicker-toggle>
      <mat-datepicker #DEFAULTJUDGEMENTDATE></mat-datepicker>
      @if (testBool && toolTipList?.DEFAULTJUDGEMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DEFAULTJUDGEMENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.DEFAULTJUDGEMENTDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INTERESTRATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INTERESTRATE),
      }"
    >
      <mat-label>Interest Rate</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'percent', 'INTERESTRATE')"
        matInput
        formControlName="INTERESTRATE"
        matTooltip="{{ toolTipList ? toolTipList?.INTERESTRATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
      />
      @if (testBool && toolTipList?.INTERESTRATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INTERESTRATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.INTERESTRATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.DJINTERESTRATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.DJINTERESTRATE),
      }"
    >
      <mat-label>DJ Interest Rate</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'percent', 'DJINTERESTRATE')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.INTERESTRATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="DJINTERESTRATE"
      />
      @if (testBool && toolTipList?.DJINTERESTRATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.DJINTERESTRATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.DJINTERESTRATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INTERESTENDDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INTERESTENDDATE),
      }"
    >
      <mat-label>Interest End Date</mat-label>
      <input
        (dateInput)="InterestndDateSelect('input', $event)"
        (dateChange)="InterestndDateSelect('change', $event)"
        matInput
        [matDatepicker]="INTERESTENDDATE"
        matTooltip="{{ toolTipList ? toolTipList?.INTERESTENDDATETEXT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="INTERESTENDDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="INTERESTENDDATE"></mat-datepicker-toggle>
      <mat-datepicker #INTERESTENDDATE></mat-datepicker>
      @if (testBool && toolTipList?.INTERESTENDDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INTERESTENDDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.INTERESTENDDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FINALPAYMENTDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FINALPAYMENTDATE),
      }"
    >
      <mat-label>Final Payment Date</mat-label>
      <input
        (dateInput)="FinalpaymentDateSelect('input', $event)"
        (dateChange)="FinalpaymentDateSelect('change', $event)"
        matInput
        [matDatepicker]="FINALPAYMENTDATE"
        matTooltip="{{ toolTipList ? toolTipList?.INTERESTRATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="FINALPAYMENTDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="FINALPAYMENTDATE"></mat-datepicker-toggle>
      <mat-datepicker #FINALPAYMENTDATE></mat-datepicker>
      @if (testBool && toolTipList?.FINALPAYMENTDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.FINALPAYMENTDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.FINALPAYMENTDATE?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.INTERESTTODATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.INTERESTTODATE),
      }"
    >
      <mat-label>Interest To Date</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.INTERESTTODATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="INTERESTTODATE"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.INTERESTTODATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INTERESTTODATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.INTERESTTODATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(
          errorWarningData.Error?.INTERESTSINCEDEFAULTJUDGEMENT
        ),
        'has-warning': $safeNavigationMigration(
          errorWarningData.Warning?.INTERESTSINCEDEFAULTJUDGEMENT
        ),
      }"
    >
      <mat-label>Interest Since DJ</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.INTERESTSINCEDEFAULTJUDGEMENT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="INTERESTSINCEDEFAULTJUDGEMENT"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.INTERESTSINCEDEFAULTJUDGEMENT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.INTERESTSINCEDEFAULTJUDGEMENT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.INTERESTSINCEDEFAULTJUDGEMENT?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.FILINGFEES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.FILINGFEES),
      }"
    >
      <mat-label>Filing Fees</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.FILINGFEES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="FILINGFEES"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.FILINGFEES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.FILINGFEES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.FILINGFEES?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="33"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.ADDITIONALSERVICEFEES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.ADDITIONALSERVICEFEES),
      }"
    >
      <mat-label>Addit. Service Fees</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.ADDITIONALSERVICEFEES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="ADDITIONALSERVICEFEES"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.ADDITIONALSERVICEFEES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.ADDITIONALSERVICEFEES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.ADDITIONALSERVICEFEES?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="34"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SERVICEFEES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SERVICEFEES),
      }"
    >
      <mat-label>Service Fees</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.SERVICEFEES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SERVICEFEES"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.SERVICEFEES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.SERVICEFEES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SERVICEFEES?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.GARNISHEETOTAL),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.GARNISHEETOTAL),
      }"
    >
      <mat-label>Garnishee Total</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.GARNISHEETOTAL?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="GARNISHEETOTAL"
        currencyMask
        readonly
      />
      @if (testBool && toolTipList?.GARNISHEETOTAL) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.GARNISHEETOTAL.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.GARNISHEETOTAL?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.SOLICITORSFEES),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.SOLICITORSFEES),
      }"
    >
      <mat-label>Solicitors Fees</mat-label>
      <input
        (focusout)="changeValue($event.target.value, 'number')"
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.SOLICITORSFEES?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="SOLICITORSFEES"
        style="text-align: right"
        type="text"
        mask="separator.2"
        thousandSeparator=","
        decimalMarker="."
        [leadZero]="true"
      />
      @if (testBool && toolTipList?.SOLICITORSFEES) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.SOLICITORSFEES.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.SOLICITORSFEES?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.TOTALDEBT),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.TOTALDEBT),
      }"
    >
      <mat-label>Total Debt</mat-label>
      <input
        matInput
        matTooltip="{{ toolTipList ? toolTipList?.TOTALDEBT?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="TOTALDEBT"
        currencyMask
        readonly
      />
      @if (testBool && toolTipList.TOTALDEBT) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.TOTALDEBT.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.TOTALDEBT?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
    <mat-form-field
      appearance="outline"
      fxFlex="25"
      class="pr-1"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData.Error?.REVIEWDATE),
        'has-warning': $safeNavigationMigration(errorWarningData.Warning?.REVIEWDATE),
      }"
    >
      <mat-label>Review Date</mat-label>
      <input
        (dateInput)="ReviewDateSelect('input', $event)"
        (dateChange)="ReviewDateSelect('change', $event)"
        matInput
        [matDatepicker]="REVIEWDATE"
        matTooltip="{{ toolTipList ? toolTipList?.REVIEWDATE?.HOVER : '' }}"
        [matTooltipPosition]="toolTipPostion"
        formControlName="REVIEWDATETEXT"
      />
      <mat-datepicker-toggle matSuffix [for]="REVIEWDATE"></mat-datepicker-toggle>
      <mat-datepicker #REVIEWDATE></mat-datepicker>
      @if (testBool && toolTipList?.REVIEWDATE) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.REVIEWDATE.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList ? $safeNavigationMigration(toolTipList?.REVIEWDATE?.COPYVALUE) : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
  <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
    <!-- <mat-form-field appearance="outline" fxFlex="100"
                    [ngClass]="{'has-error':errorWarningData.Error?.REPAYMENTDETAILS,'has-warning':errorWarningData.Warning?.REPAYMENTDETAILS}">
                    <mat-label>Repayment Details</mat-label>
                    <textarea matInput matTooltip="{{(toolTipList)?toolTipList?.REPAYMENTDETAILS?.HOVER:''}}" [matTooltipPosition]="toolTipPostion" formControlName="REPAYMENTDETAILS"></textarea>
                    <div  *ngIf="testBool && toolTipList?.REPAYMENTDETAILS" class="tooltip-wrap" ><input id="myInput" readonly disabled value="{{(toolTipList)?toolTipList?.REPAYMENTDETAILS.COPYVALUE:''}}"><mat-icon (click)="tooltipService.copyTooltipText((toolTipList)?toolTipList?.REPAYMENTDETAILS?.COPYVALUE:'')">file_copy</mat-icon></div>
                  </mat-form-field> -->

    <mat-form-field
      appearance="outline"
      class="full-width pr-1"
      fxFlex="100"
      [ngClass]="{
        'has-error': $safeNavigationMigration(errorWarningData?.Error?.REPAYMENTDETAILS),
        'has-warning': $safeNavigationMigration(errorWarningData?.Warning?.REPAYMENTDETAILS),
      }"
    >
      <mat-label>Repayment Details</mat-label>

      <textarea
        matInput
        formControlName="REPAYMENTDETAILS"
        [matTooltip]="toolTipList?.REPAYMENTDETAILS?.HOVER || ''"
        [matTooltipPosition]="toolTipPostion"
        rows="4"
        (keydown.enter)="$event.stopImmediatePropagation()"
      ></textarea>
      @if (testBool && toolTipList?.REPAYMENTDETAILS) {
        <div class="tooltip-wrap">
          <input
            id="myInput"
            readonly
            disabled
            value="{{ toolTipList ? toolTipList?.REPAYMENTDETAILS.COPYVALUE : '' }}"
          />
          <mat-icon
            (click)="
              tooltipService.copyTooltipText(
                toolTipList
                  ? $safeNavigationMigration(toolTipList?.REPAYMENTDETAILS?.COPYVALUE)
                  : ''
              )
            "
          >
            file_copy
          </mat-icon>
        </div>
      }
    </mat-form-field>
  </div>
</form>
